import styled from "styled-components"

export const LogoHeading = styled.h1`
  font-size: 60px;
  font-family: adobe-caslon-pro, serif;
  font-weight: 600;
  font-style: normal;
`

export const H1 = styled.h1`
  font-weight: bold;
  font-size: 60px;
  font-family: "Patua One", cursive;
`

export const H2 = styled.h2`
  font-size: 40px;
  font-family: adobe-caslon-pro, serif;
  font-weight: 600;
  font-style: normal;
`

export const textButton = styled.h2`
  font-weight: bold;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 30px;
  color: #26b3ff;
`
export const description = styled.h1`
  font-family: "Open Sans", sans-serif;
  font-size: 20px;
  color: black;
  font-weight: bold;
`

export const tagLine = styled.h1`
  font-family: adobe-caslon-pro, serif;
  font-weight: 600;
  font-style: italic;
  font-size: 20px;
`

export const subtitleTextStyle = styled.p`
  font-weight: medium;
  font-size: 17px;
  color: blue;
`

export const H3 = styled.h3`
  font-weight: bold;
  font-size: 30px;
  font-family: "Vesper Libre", serif;
`

export const BodyIntro = styled.p`
  font-weight: 500;
  font-size: 24px;
  line-height: 140%;
`

export const BodyMain = styled.p`
  font-weight: normal;
  font-size: 20px;
  line-height: 140%;
`

export const MediumText = styled.p`
  font-weight: normal;
  font-size: 17px;
  line-height: 130%;
`

export const Caption = styled.p`
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  font-family: "Odibee Sans", cursive;
`

export const Caption2 = styled.p`
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  text-transform: uppercase;
`

export const SmallText = styled.p`
  font-weight: normal;
  font-size: 13px;
  line-height: 130%;
`

export const SmallText2 = styled.p`
  font-weight: 600;
  font-size: 13px;
  line-height: 130%;
  text-transform: uppercase;
`
